import { type ReactElement, useEffect } from 'react';
import Spinner from '../Spinner';
import styles from './style.module.scss';
import { useToast } from '@/providers/toast-provider/utils/use-toast';

interface LoadingProperties {
  readonly dataTestid?: string;
  readonly isLoading?: boolean;
  readonly isError?: boolean;
}

const GlobalLoading = ({ isLoading, isError, dataTestid }: LoadingProperties): ReactElement | null => {
  const showToast = useToast();

  useEffect(() => {
    if (isError) {
      showToast({
        header: 'Something went wrong',
        message: 'Reload the page or try it again later',
        variant: 'error',
      });
    }
  }, [isError, showToast]);

  if (isLoading) {
    return (
      <div className={styles.container} data-testid={dataTestid}>
        <Spinner size="lg" />
      </div>
    );
  }

  return null;
};

export default GlobalLoading;
